import React from "react";
import ResearchAndDevlopRedesign from "../redesign/ResearchAndDevlopRedesign";

const ResearchAndDevlop = () => {
  return <ResearchAndDevlopRedesign />;
};

export default ResearchAndDevlop;
